import { getData, postData } from '../../../utils/fetch-api-util';
import { GameProfileResponse, GameProfileItem } from '../../../types/gameProfile';
import { API_URLS } from '../../../constants/urls/api-urls';

export const getGameProfilesRepository = async (country?: string | null): Promise<GameProfileResponse> => {
  const url = country ? `${API_URLS.GAME_PROFILE_API}?country=${country}` : API_URLS.GAME_PROFILE_API;
  const response = await getData(url);
  return response.data as GameProfileResponse;
};

// Entry Card APIs
export const createOrUpdateGameProfileEntryCardRepository = async (
  data: Partial<GameProfileItem>,
): Promise<GameProfileItem> => {
  const response = await postData(API_URLS.GAME_PROFILE_ENTRY_CARD_API, data);
  return response.data as GameProfileItem;
};

// Questionnaire APIs
export const createOrUpdateGameProfileQuestionnaireRepository = async (
  data: Partial<GameProfileItem>,
): Promise<GameProfileItem> => {
  const response = await postData(API_URLS.GAME_PROFILE_QUESTIONNAIRE_API, data);
  return response.data as GameProfileItem;
};
